import axios from "axios";
import {
  getToken as _getTokenFromRefresh,
  handleAuthError,
  resetAuthRetryCount,
  createAuthRetryState,
} from "./_tokenRefresh";

// TODO: Change later
export let baseUrl = "https://api-inbox.skedsocial.com";

// for when you're testing the API locally
let useLocal = false;

// SKED_API_ENV overrides NODE_ENV for API URL selection
const apiEnv = process.env.SKED_API_ENV || process.env.NODE_ENV;

if (apiEnv === "staging" || apiEnv === "dev") {
  if (useLocal) {
    baseUrl = "http://localhost:5001";
  } else {
    baseUrl = "https://api-inbox-staging.skedsocial.com";
  }
}

const defaultOptions = {
  baseURL: baseUrl,
  headers: {
    "Content-Type": "application/json",
  },
};

export function getToken() {
  return _getTokenFromRefresh();
}

export const skedInboxApi = axios.create(defaultOptions);

skedInboxApi.interceptors.request.use(async (config) => {
  const token = await getToken();
  config.headers.Authorization = `Bearer ${token}`;
  return config;
}, null);

const skedInboxApiRetryState = createAuthRetryState();

skedInboxApi.interceptors.response.use(
  (response) => {
    resetAuthRetryCount(skedInboxApiRetryState);
    return response;
  },
  async (error) => {
    if (error && error.response && error.response.status === 401) {
      return handleAuthError(
        skedInboxApi,
        error,
        "skedInboxApi",
        skedInboxApiRetryState
      );
    } else {
      return Promise.reject(error);
    }
  }
);
